export default __webpack_public_path__ + "static/media/plate1.50d0591a.png";